import type { PromotionProps } from 'tsconfig/types';
import { globals } from '../../../utils/globals';
import { isInDateRange } from '../../../utils/helperFunction';
import type { Sku } from '../types/PricingAndPurchasePanel.types';

type PageInfo = {
  brand?: string;
};
export const brandLocaleMap: Record<string, string> = {
  law: 'en_GB_UKLAIT',
  bbc: 'en_GB_UKLAIT',
  avy: 'en_GB_UKAVRY',
  stw: 'en_GB_UKCLUB',
};
export const allowingPromotionForCurrEnvironment = (promotions: PromotionProps[], pageInfo: PageInfo): boolean[] => {
  // checking for brand and pomotional locale data
  if (!promotions || !pageInfo?.brand) {
    return [false];
  }

  const targetLocale = brandLocaleMap[pageInfo.brand];
  if (!targetLocale) {
    return [false];
  }

  return promotions.map(promo => promo.locales?.includes(targetLocale) ?? false);
};

// Fetching the Promotion and Description

export const getPromotions = (promotions: PromotionProps[], thisEnvAllowPromotion: boolean[]): PromotionProps[] | [] =>
  promotions?.filter(
    (promo: PromotionProps, index: number) =>
      thisEnvAllowPromotion[index] && promo !== undefined && isInDateRange(promo.startDate, promo.endDate),
  );

export const getPromoDescription = (promotions: PromotionProps[]): string[] | [] =>
  promotions?.map((promo: PromotionProps) => promo?.description);

export const countryUS = () => globals.country === 'us';
export const countryUK = () => globals.country === 'uk';

interface HitProps {
  enPrimeur?: boolean;
}

/**
 * Determines button text across all pages (PLP, PDP, Bottle, Case)
 * Shows "RESERVE TODAY" for presell/en primeur items
 * Localizes "ADD TO CART"/"ADD TO BASKET" based on country
 */
export const getAddToCartButtonText = (sku?: Sku, hit?: HitProps): string => {
  const isPresell = (Array.isArray(sku?.presellPayments) && (sku?.presellPayments?.length ?? 0) > 0) || hit?.enPrimeur;

  if (isPresell) {
    return 'RESERVE TODAY';
  }

  return countryUK() ? 'ADD TO BASKET' : 'ADD TO CART';
};

export const clsChrisCollection = 'christmas-collection';
export const clsLowestPrice = 'lowestPricepossible';
export const clsPresell = 'presell-primeur';
export const clsLowestPriceOffer = 'lowestPricePossibleOnOffer';
export const clsNoPillLowestPrice = 'no-pill-lowestPricepossible';
export const clsNoPillLowestPriceOffer = 'no-pill-lowestPricePossibleOnOffer';

const packingFormat = (packagingType: string): string => {
  const lowerCasePackagingType = packagingType.toLowerCase();
  switch (lowerCasePackagingType) {
    case 'wine box':
      return 'per box';
    case 'can':
      return 'per can';
    case 'case':
      return 'per case';
    default:
      return 'per bottle';
  }
};

export const getPackingFormat = (packagingType: string): string => packingFormat(packagingType);

export const getItsLowestPriceClass = (savings: number, conditionPrice = 5): string =>
  savings > conditionPrice ? clsLowestPrice : `${clsLowestPrice} ${clsNoPillLowestPrice} `;

export const getItsLowestPriceOfferClass = (savings: number, conditionPrice = 5): string =>
  savings > conditionPrice ? clsLowestPriceOffer : `${clsLowestPriceOffer} ${clsNoPillLowestPriceOffer} `;

export const getItsLowestPricePresellClass = (savings: number, conditionPrice = 5): string =>
  savings > conditionPrice
    ? `${clsLowestPrice} ${clsPresell} `
    : `${clsLowestPrice} ${clsPresell} ${clsNoPillLowestPrice} `;

export const getTieredPromoCondition = (promo: any) =>
  promo.tierUIRules && !promo.description?.includes('when added to');
